
export const getConfigValue = (paramName: string, defaultVal: any = null): any => {
    return typeof process.env[`VUE_APP_${paramName}`] !== 'undefined' ?
        process.env[`VUE_APP_${paramName}`] :
        defaultVal;
};
